import { LocationOn } from '@mui/icons-material';
import { Box, Grid, styled, Typography } from '@mui/material';
import { AutocompleteNoResults, Chip } from '@side/pantry';
import type { HTMLAttributes } from 'react';

const ListItem = styled('li')`
  /* Override disabled dimmed opacity */
  opacity: 1 !important;
`;

export const getGooglePlacesAutofillOptionKey = (
  option: google.maps.places.AutocompletePrediction,
) => {
  return `${Math.random()}-${option.description}`;
};

type Props = {
  optionProps: HTMLAttributes<HTMLLIElement>;
  option: google.maps.places.AutocompletePrediction & { noResults?: boolean };
  noResultsText?: string;
  showListingChip?: boolean;
};

export function GooglePlacesAutofillOption({
  optionProps,
  option,
  noResultsText,
  showListingChip,
}: Props) {
  const { main_text: mainText, secondary_text: secondaryText } =
    option.structured_formatting;
  if (!mainText && !secondaryText) {
    return null;
  }

  if (option.noResults) {
    return (
      <ListItem {...optionProps}>
        <AutocompleteNoResults icon={<LocationOn />} subtitle={noResultsText} />
      </ListItem>
    );
  }

  return (
    <ListItem {...optionProps}>
      <Grid
        container
        sx={{ width: '100%', alignItems: 'flex-start', flexWrap: 'nowrap' }}
      >
        <Grid>
          <Box component={LocationOn} sx={{ color: 'text.secondary', mr: 2 }} />
        </Grid>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0,
            wordBreak: 'break-word',
          }}
        >
          {(mainText || showListingChip) && (
            <Box
              sx={{
                display: 'flex',
                gap: 1,
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body2">{mainText || '-'}</Typography>
              {showListingChip && (
                <Chip
                  label="My listing"
                  color="secondary"
                  variant="outlined"
                  size="xs"
                  sx={{ flexShrink: 0 }}
                />
              )}
            </Box>
          )}
          {secondaryText && (
            <Typography
              variant="body2"
              sx={{
                pt: 0.25,
                color: 'text.secondary',
              }}
            >
              {secondaryText}
            </Typography>
          )}
        </Box>
      </Grid>
    </ListItem>
  );
}
